import { Link } from 'react-router-dom';
import { openSupportChat } from '@/utils/supportChat';

const TRUST_ITEMS = [
  { icon: 'ri-shield-check-line', text: 'No martingale · No grid' },
  { icon: 'ri-robot-2-line', text: 'Fully automated, runs unattended' },
  { icon: 'ri-price-tag-3-line', text: '100% free, forever' },
];

export default function Hero() {
  return (
    <section className="relative w-full min-h-[640px] md:min-h-[740px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20financial%20background%20with%20glowing%20golden%20candlestick%20chart%20lines%20and%20soft%20bokeh%20particles%2C%20deep%20charcoal%20green%20to%20black%20gradient%2C%20luxurious%20molten%20gold%20accents%2C%20cinematic%20depth%20of%20field%2C%20minimal%20futuristic%20fintech%20aesthetic%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=hero-xauusd-01&orientation=landscape"
          alt="Abstract dark gold trading chart background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-950/75 to-primary-950/92"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-14 md:pb-16">
        <div className="max-w-shell mx-auto w-full">
          <div className="flex flex-col items-center text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/[0.07] px-4 py-1.5 text-xs md:text-sm font-medium text-background-100 backdrop-blur-sm animate-fade-in">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-dot" aria-hidden="true"></span>
              Live MT5 gold account · performance published here
            </span>

            <h1 className="mt-6 font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-[1.08] max-w-4xl text-balance animate-fade-up">
              The free XAUUSD Expert Advisor for MetaTrader 5
            </h1>

            <p className="mt-6 max-w-2xl text-sm md:text-lg leading-relaxed text-background-200/90 animate-fade-up" style={{ animationDelay: '120ms' }}>
              GoldWarden trades gold automatically with hard risk limits — no martingale, no grid.
              Review the live account performance, then get the EA free through our support chat.
            </p>

            <p className="mt-3 max-w-2xl text-xs md:text-sm leading-relaxed text-background-200/70 animate-fade-up" style={{ animationDelay: '160ms' }}>
              New to this? An Expert Advisor is simply a robot that trades gold (XAUUSD) for you
              inside MetaTrader 5 — the platform your broker provides. No coding required.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto animate-fade-up" style={{ animationDelay: '220ms' }}>
              <button
                type="button"
                onClick={openSupportChat}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 hover:bg-accent-400 px-7 py-3.5 text-sm md:text-base font-semibold text-primary-950 transition-all duration-200 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-customer-service-2-line text-lg" aria-hidden="true"></i>
                Get EA Free
              </button>
              <Link
                to="/performance"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-background-50/30 bg-background-50/[0.06] hover:bg-background-50/[0.12] px-7 py-3.5 text-sm md:text-base font-semibold text-background-50 backdrop-blur-sm transition-colors whitespace-nowrap"
              >
                <i className="ri-bar-chart-2-line text-lg" aria-hidden="true"></i>
                See Live Performance
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
              {TRUST_ITEMS.map((item) => (
                <span key={item.text} className="inline-flex items-center gap-2 text-xs md:text-sm text-background-200/85">
                  <i className={`${item.icon} text-accent-400`} aria-hidden="true"></i>
                  {item.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}